import React from "react";
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { financialMetricsSummaryResponse } from "@/services/api/finbox-endpoints";

export default function FinancialMetricsSummary(props: { data: financialMetricsSummaryResponse }) {
  const allPeriods = Array.from(
    new Set(props.data.lineItems.flatMap((li) => li.periodValues.map((p) => p.period)))
  );

  return (
    <Card variant="outlined" sx={{ borderRadius: 2 }}> 
      <CardContent sx={{ pt: 0, "&:last-child": { pb: 2 } }}>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, color: "text.secondary" }}>Metric</TableCell>
                {allPeriods.map((p) => (
                  <TableCell
                    key={p}
                    align="right"
                    sx={{ fontWeight: 600, color: "text.secondary" }}
                  >
                    {p}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {props.data.lineItems.map((li) => (
                <TableRow key={li.title} hover>
                  <TableCell sx={{ fontWeight: 500 }}>{li.title}</TableCell>
                  {allPeriods.map((p) => {
                    const value = li.periodValues.find((x) => x.period === p)?.value;
                    return (
                      <TableCell key={p} align="right">
                        {value ?? "—"}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
}
